module.exports = __webpack_public_path__ + "static/media/place_white_24dp.e4c09f55.svg";